import React, { useContext, useEffect } from "react";
import Cookie from "js-cookie";
import UserContext from "./UserContext";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Main from "./pages/Main";
import Dashboard from "./pages/Dashboard/Dashboard";
import AddDevice from "./pages/Device/AddDevice/AddDevice";
import DeviceDetail from "./pages/Device/AddDevice/DeviceDetail";
import FindUser from "./pages/User/FindUser";
import Login from "./pages/Auth/Login";
import UserHouseList from "./pages/User/UserHouseList";
import UserDeviceList from "./pages/User/UserDeviceList";
import UserAutomationList from "./pages/User/UserAutomationList";
import UserGroupDetail from "./pages/User/UserGroupDetail";
import AutomationDetail from "./pages/User/AutomationDetail";
import SwitchActivityLog from "./pages/User/logs/SwitchActivityLog";
import AutomationStatusLog from "./pages/User/logs/AutomationStatusLog";
import AutomationUpdateLog from "./pages/User/logs/AutomationUpdateLog";
import UpdateLogDetail from "./pages/User/logs/UpdateLogDetail";
import SwitchStateLog from "./pages/User/logs/SwitchStateLog";
import DcDeviceDetail from "./pages/Dashboard/DcDeviceDetail";
import ZigBee from "./pages/Device/AddDeviceZigBee/ZigBee";
import ThChart from "./components/chart/ThChart";
import ZlanType from "./pages/Device/AddZlan/ZlanType";
import AddmA from "./pages/Device/AddZlan/AddmA";
import AddRS485 from "./pages/Device/AddZlan/AddRS485";
import FeedBack from "./pages/Dashboard/FeedBack";
import AdminList from "./pages/CreateAdmin/AdminList";
import Lora from "./pages/Device/AddLora/Lora";
import AddInterval from "./pages/Device/AddDevice/AddInterval";
import Profile from "./pages/Settings/Profile";
import BlockUser from "./pages/Dashboard/BlockUser";
import Notification from "./pages/User/notification/Notification";
import Command from "./pages/User/command/Command";
import ZigbeeThActivityLog from "./pages/User/logs/ZigbeeThActivityLog";
import SearchDevice from "./pages/Device/AddDevice/SearchByDevice/SearchDevice";
import DeletedDevicesDetail from "./pages/Dashboard/DeletedDevicesDetail";
import Banner from "./pages/Settings/Banner";
import SearchDetail from "./pages/Device/AddDevice/SearchByDevice/SearchDetail";
import ShareDevice from "./pages/User/ShareDevice";
import DeviceCategory from "./pages/DeviceCategory";
import NotificationList from "./pages/Notification/NotificationList";
import NotificationDetail from "./pages/Notification/NotificationDetail";
import ZlanChart from "./components/chart/ZlanChart";
import SensorStateLog from "./pages/User/logs/SensorStateLog";
import CreateInvoice from "./pages/Invoice/CreateInvoice";
import UserTtrList from "./pages/User/UserTtrList";
import UserTtrDetail from "./pages/User/UserTtrDetail";
import TtrStatusLog from "./pages/User/logs/TtrStateLog";
import TtrUpdateLog from "./pages/User/logs/TtrUpdateLog";
import TtrStateLogDetail from "./pages/User/logs/TtrStateLogDetail";
import TtrUpdateLogDetail from "./pages/User/logs/TtrUpdateLogDetail";
import UserRestrict from "./pages/Invoice/UserRestrict";
import LoraSmtcChart from "./components/chart/LoraSmtcChart";
import Knx from "./pages/Device/knx/Knx";
import Ir from "./pages/Device/IR/Ir";
import LoraLgtChart from "./components/chart/LoraLgtChart";
import ApiService from "./pages/Api-service/ApiService";
import SharedDeviceList from "./pages/Api-service/SharedDeviceList";
import ApiShareDevice from "./pages/Api-service/ApiShareDevice";
import ShareDeviceZlan from "./pages/User/ShareDeviceZlan";
import IrSubDevices from "./pages/Device/IR/IrSubDevices";
import Analyze from "./pages/User/analyze/Analyze";
import UserLocation from "./pages/User/map/UserLocation";
import Complain from "./pages/User/complain/Complain";
import DeviceList from "./pages/System/Devices/DeviceList";
import Instruction from "./pages/System/Instruction/Instruction";
import AddDeviceSys from "./pages/System/Devices/AddDeviceSys";
import G4 from "./pages/Device/G4/G4";
import G4Multi from "./pages/Device/G4/G4Multi";
import LoraThChart from "./components/chart/LoraThChart";
import ZbAqiChart from "./components/chart/ZbAqiChart";
import AQsensor from "./pages/Device/AQsensor/AQsensor";
import AddAQ from "./pages/Device/AQsensor/AddAQ";
import G4Detail from "./pages/User/g4/G4Detail";
import Calculator from "./pages/System/calculator/Calculator";
import Invoice from "./pages/System/invoice/Invoice";
import DeviceInvoice from "./pages/System/invoice/create/DeviceInvoice";

const App = () => {
  const context = useContext(UserContext);
  const accessToken = Cookie.get("accessToken");
  const isLog = Cookie.get("isLoggedIn");
  const role = Cookie.get("role");

  return (
    <Router>
      {isLog && accessToken ? (
        <Main>
          <Switch>
            <Route exact path="/dashboard">
              <Dashboard />
            </Route>
            <Route exact path="/profile">
              <Profile />
            </Route>
            <Route exact path="/banner">
              <Banner />
            </Route>
            <Route exact path="/dashboard/feedback">
              <FeedBack />
            </Route>
            <Route exact path="/dashboard/dcdevice-detail">
              <DcDeviceDetail />
            </Route>
            <Route exact path="/dashboard/deleted-devices">
              <DeletedDevicesDetail />
            </Route>
            <Route exact path="/device/type">
              <DeviceCategory />
            </Route>
            <Route exact path="/device/type/add-device">
              <AddDevice />
            </Route>
            <Route exact path="/device/type/add-device/device-detail">
              <DeviceDetail />
            </Route>
            <Route exact path="/device/search">
              <SearchDevice />
            </Route>
            <Route exact path="/device/search/device-detail">
              <SearchDetail />
            </Route>
            <Route exact path="/device/interval">
              <AddInterval />
            </Route>
            <Route exact path="/device/type/zigbee">
              <ZigBee />
            </Route>
            <Route exact path="/device/type/zlan">
              <ZlanType />
            </Route>
            <Route exact path="/device/type/zlan/add-zlan-ma">
              <AddmA />
            </Route>
            <Route exact path="/device/type/zlan/add-zlan-rs">
              <AddRS485 />
            </Route>
            <Route exact path="/device/type/lora">
              <Lora />
            </Route>
            <Route exact path="/device/type/knx">
              <Knx />
            </Route>
            <Route exact path="/device/type/ir">
              <Ir />
            </Route>
            <Route exact path="/device/type/g4">
              <G4 />
            </Route>
            <Route exact path="/device/type/g4-multi">
              <G4Multi />
            </Route>
            <Route exact path="/device/type/aq">
              <AQsensor />
            </Route>
            <Route exact path="/device/type/aq-sensor">
              <AddAQ />
            </Route>
            <Route exact path="/User/find">
              <FindUser />
            </Route>
            <Route exact path="/User/notification">
              <Notification />
            </Route>
            <Route exact path="/User/block">
              <BlockUser />
            </Route>
            <Route exact path="/User/analyze">
              <Analyze />
            </Route>
            <Route exact path="/User/location">
              <UserLocation />
            </Route>
            <Route exact path="/User/complain">
              <Complain />
            </Route>
            <Route path="/User/find/house-list">
              <UserHouseList />
            </Route>
            <Route path="/User/find/device-list">
              <UserDeviceList />
            </Route>
            <Route path="/User/find/ir-detail">
              <IrSubDevices />
            </Route>

            <Route path="/User/find/g4-detail">
              <G4Detail />
            </Route>
            <Route path="/User/find/automation-list">
              <UserAutomationList />
            </Route>
            <Route path="/User/find/automation-detail">
              <AutomationDetail />
            </Route>
            <Route path="/User/find/group-detail">
              <UserGroupDetail />
            </Route>
            <Route path="/User/find/ttr-list">
              <UserTtrList />
            </Route>
            <Route path="/User/find/ttr-detail">
              <UserTtrDetail />
            </Route>
            <Route path="/User/find/ttr-status-log">
              <TtrStatusLog />
            </Route>
            <Route path="/User/find/ttr-status-log-detail">
              <TtrStateLogDetail />
            </Route>
            <Route path="/User/find/ttr-update-log">
              <TtrUpdateLog />
            </Route>
            <Route path="/User/find/ttr-update-log-detail">
              <TtrUpdateLogDetail />
            </Route>
            <Route path="/User/find/switch-state-log">
              <SwitchStateLog />
            </Route>
            <Route path="/User/find/sensor-state-log">
              <SensorStateLog />
            </Route>
            <Route path="/User/find/switch-activity-log">
              <SwitchActivityLog />
            </Route>
            <Route path="/User/find/zigbeeTh-activity-log">
              <ZigbeeThActivityLog />
            </Route>
            <Route path="/User/find/chart">
              <ThChart />
            </Route>
            <Route path="/User/find/Zlan-chart">
              <ZlanChart />
            </Route>
            <Route path="/User/find/zbAqi-chart">
              <ZbAqiChart />
            </Route>
            <Route path="/User/find/LoraSmtc-chart">
              <LoraSmtcChart />
            </Route>
            <Route path="/User/find/LoraLgt-chart">
              <LoraLgtChart />
            </Route>
            <Route path="/User/find/LoraTh-chart">
              <LoraThChart />
            </Route>
            <Route path="/User/find/automation-status-log">
              <AutomationStatusLog />
            </Route>
            <Route path="/User/find/automation-update-log">
              <AutomationUpdateLog />
            </Route>
            <Route path="/User/find/update-log-detail">
              <UpdateLogDetail />
            </Route>
            <Route path="/User/find/share-device">
              <ShareDevice />
            </Route>
            <Route path="/User/find/share-device-zlan">
              <ShareDeviceZlan />
            </Route>
            <Route path="/User/find/command">
              <Command />
            </Route>
            <Route path="/admin-list">
              <AdminList />
            </Route>
            <Route exact path="/notification">
              <NotificationList />
            </Route>
            <Route path="/notification/detail">
              <NotificationDetail />
            </Route>
            <Route exact path="/invoice">
              <CreateInvoice />
            </Route>
            <Route path="/invoice/restrict">
              <UserRestrict />
            </Route>
            <Route exact path="/api">
              <ApiService />
            </Route>
            <Route path="/api/shared-device-list">
              <SharedDeviceList />
            </Route>
            <Route path="/api/share-device">
              <ApiShareDevice />
            </Route>
            <Route exact path="/system/device-list">
              <DeviceList />
            </Route>
            <Route path="/system/add-device">
              <AddDeviceSys />
            </Route>
            <Route exact path="/system/instruction">
              <Instruction />
            </Route>
            <Route exact path="/system/calculator">
              <Calculator />
            </Route>
            <Route exact path="/system/invoice">
              <Invoice />
            </Route>
            <Route exact path="/system/invoice/create">
              <DeviceInvoice />
            </Route>
            <Redirect
              to={
                role === "techsub" || role === "techmonitor"
                  ? "/device/type"
                  : "/dashboard"
              }
            />
          </Switch>
        </Main>
      ) : (
        <>
          <Route exact path="/login">
            <Login />
          </Route>
          <Redirect to="/login" />
        </>
      )}
    </Router>
  );
};

export default App;

// import React from "react";

// function App() {
//   return (
//     <div>
//       {/* HEADER */}
//       <div
//         style={{
//           width: "100%",
//           height: "60px",
//           background: "black",
//           color: "#ffffff",
//           gap: "12px",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <p>Home</p>
//         <p>Shop</p>
//         <p>Products</p>
//         <p>Detail</p>
//         <p>Contact</p>
//       </div>

//       {/* BODY */}
//       <div style={{ height: "300vh", background: "yellow" }}></div>
//     </div>
//   );
// }

// export default App;

// import React, { useEffect, useState } from "react";

// function App() {
//   const [headerState, setHeaderState] = useState("first"); // "first", "none", "second"
//   const [hover, setHover] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollY = window.scrollY;

//       if (scrollY < 100) {
//         setHeaderState("first");
//       } else if (scrollY >= 100 && scrollY < 950) {
//         setHeaderState("none");
//       } else {
//         setHeaderState("second");
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div>
//       {/* First Header */}
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           height: "60px",
//           border: "1px solid black",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "12px",
//           transition: "opacity 0.5s, transform 0.5s",
//           // transition: "opacity 0.3s ease, transform 0.3s ease 0.3s", // 👈 updated
//           opacity: headerState === "first" ? 1 : 0,
//           transform:
//             headerState === "first" ? "translateY(0)" : "translateY(-100%)",
//           pointerEvents: headerState === "first" ? "auto" : "none",
//           zIndex: 2,
//         }}
//       >
//         <p>Home</p>
//         <p>Shop</p>
//         <p>Products</p>
//         <p>Detail</p>
//         <p>Contact</p>
//       </div>

//       {/* Second Header */}
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           height: "60px",
//           background: "white",
//           color: "black",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "12px",
//           transition: "opacity 0.3s, transform 0.4s",
//           // transition: "opacity 0.3s ease, transform 0.3s ease 0.3s", // 👈 updated
//           opacity: headerState === "second" ? 1 : 0,
//           transform:
//             headerState === "second" ? "translateY(0)" : "translateY(-100%)",
//           pointerEvents: headerState === "second" ? "auto" : "none",
//           boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//         }}
//       >
//         <svg
//           style={{
//             position: "absolute",
//             transition: "transform 0.125s linear",
//             left: "100px",
//             // transition: "opacity 0.3s, transform 0.4s",
//             transition:
//               "opacity 0.3s ease, transform 0.4s cubic-bezier(0.22, 1.61, 0.36, 1)",
//             transform:
//               headerState === "second" ? "translateY(0)" : "translateY(-100%)",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.transform = "translateY(14px)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.transform = "translateY(0)";
//           }}
//           version="1.1"
//           id="Layer_1"
//           xmlns="http://www.w3.org/2000/svg"
//           xmlnsXlink="http://www.w3.org/1999/xlink"
//           x="0px"
//           y="0px"
//           width="36px"
//           height="152.135px"
//           viewBox="0 0 36 152.135"
//           enable-background="new 0 0 36 152.135"
//           xmlSpace="preserve"
//         >
//           <path
//             class="scarf"
//             d="M23.721,0.017c-0.25,0.069-0.402,0.336-0.333,0.587
//   c0.028,0.102,0.056,0.205,0.083,0.308c-0.047-0.016-0.097-0.024-0.147-0.024c-0.042,0-0.084,0.005-0.125,0.017
//   c-3.088,0.888-6.226,1.628-9.413,2.056c0.042-0.005,0.085-0.011,0.127-0.016C11.171,3.307,8.38,3.446,5.631,3.099
//   C5.499,3.081,5.367,3.062,5.235,3.043C5.103,3.022,4.988,3.02,4.868,3.09C4.801,3.129,4.745,3.184,4.705,3.249
//   c-0.027,0.002-0.054,0.007-0.08,0.014C4.506,3.295,4.402,3.375,4.339,3.482C4.28,3.583,4.248,3.736,4.292,3.85
//   C5.026,5.756,5.607,7.711,6.072,9.7c0.461,1.967,0.796,3.961,1.069,5.963c0-0.001,0-0.002,0-0.004c0,0.002,0.001,0.003,0.001,0.005
//   c0,0,0,0-0.001-0.001c0.001,0.008,0.002,0.017,0.004,0.025c-0.001-0.007-0.002-0.016-0.003-0.024
//   c0.005,0.041,0.011,0.081,0.016,0.122c-0.003-0.021-0.006-0.044-0.009-0.065c0.465,3.533,0.72,7.086,0.975,10.64
//   c0.126,1.763,0.255,3.527,0.412,5.29c0.074,0.846,0.162,1.691,0.249,2.536c0.103,0.992,0.195,1.985,0.28,2.979
//   c0.665,7.718,0.825,15.472,0.752,23.214c-0.073,7.796-0.416,15.586-0.715,23.375c-0.305,7.935-0.628,15.869-1.111,23.795
//   c-0.32,5.248-0.715,10.492-1.218,15.725c-0.174,0.031-0.325,0.154-0.376,0.339c-0.067,0.245,0.081,0.527,0.333,0.588
//   c3.068,0.732,6.156,1.375,9.246,2.007c1.542,0.315,3.086,0.631,4.628,0.949c1.411,0.291,2.845,0.463,4.272,0.659
//   c1.529,0.209,3.062,0.441,4.55,0.862c0.186,0.053,0.381-0.02,0.498-0.162c0.012,0.001,0.023,0.001,0.034,0.001
//   c0.262,0,0.475-0.217,0.478-0.477c0.129-16.827-0.68-33.643-1.765-50.43c-0.136-2.101-0.281-4.202-0.41-6.304
//   c-0.128-2.116-0.241-4.232-0.345-6.349c-0.208-4.231-0.375-8.463-0.537-12.696c-0.163-4.232-0.321-8.464-0.509-12.694
//   c-0.094-2.116-0.197-4.231-0.311-6.346c-0.109-2.029-0.254-4.058-0.329-6.088c-0.328-8.931,0.488-18.062-1.922-26.783
//   C24.25,0.141,24.054,0,23.845,0C23.803,0,23.762,0.005,23.721,0.017z M5.503,3.083C5.546,3.087,5.587,3.093,5.63,3.099
//   C5.588,3.093,5.546,3.088,5.503,3.083z M5.373,4.018C5.373,4.018,5.373,4.018,5.373,4.018c0.561,1.508,1.045,3.09,1.464,4.792
//   C6.437,7.188,5.957,5.587,5.373,4.018z M6.839,8.82c0.005,0.022,0.01,0.043,0.016,0.064C6.85,8.863,6.845,8.842,6.839,8.82z"
//           ></path>
//           <path
//             class="scarf"
//             d="M7.006,121.822c-0.251,0.069-0.403,0.336-0.333,0.587
//   c0.095,0.346,0.164,0.697,0.215,1.052c0.203,1.607,0.079,3.247-0.134,4.846c-0.268,1.941-0.689,3.858-1.18,5.754
//   c-0.435,1.677-0.932,3.337-1.47,4.984c-0.081,0.247,0.092,0.521,0.333,0.587c0.26,0.072,0.507-0.086,0.587-0.333
//   c0.654-2.002,1.247-4.025,1.743-6.072c0.28-1.154,0.526-2.316,0.726-3.487c0.194-1.141,0.344-2.291,0.413-3.446
//   c0.043-0.718,0.049-1.438,0.002-2.155c-0.045-0.667-0.138-1.339-0.316-1.984c-0.058-0.209-0.254-0.35-0.463-0.35
//   C7.089,121.806,7.047,121.811,7.006,121.822z"
//           ></path>
//           <path
//             class="scarf"
//             d="M9.253,122.412c0.169,2.85,0.054,5.709-0.32,8.539
//   c0.002-0.014,0.004-0.028,0.006-0.042c-0.003,0.023-0.007,0.046-0.01,0.069c-0.002,0.019-0.005,0.038-0.008,0.057
//   c0.001-0.009,0.002-0.019,0.003-0.028c-0.428,3.102-1.163,6.153-2.14,9.127c-0.082,0.248,0.092,0.521,0.333,0.588
//   c0.26,0.072,0.507-0.086,0.588-0.333c0.94-2.865,1.656-5.8,2.091-8.783c0.434-2.984,0.587-6.003,0.421-9.014
//   c-0.003-0.061-0.007-0.121-0.011-0.181c-0.015-0.26-0.205-0.478-0.478-0.478C9.482,121.934,9.238,122.152,9.253,122.412z
//    M8.925,131.007c0.002-0.01,0.003-0.02,0.004-0.029c0.001-0.009,0.002-0.019,0.003-0.027C8.931,130.97,8.928,130.988,8.925,131.007z
//   "
//           ></path>
//           <path
//             class="scarf"
//             d="M12.205,122.728c-0.083,0.083-0.151,0.217-0.14,0.338
//   c0.165,1.833,0.061,3.679-0.18,5.5c-0.582,4.225-1.86,8.319-3.203,12.354c-0.082,0.247,0.092,0.521,0.333,0.587
//   c0.261,0.072,0.505-0.086,0.587-0.333c0.853-2.563,1.669-5.141,2.312-7.767c0.332-1.356,0.614-2.726,0.823-4.106
//   c0.205-1.35,0.339-2.71,0.362-4.075c0.011-0.721-0.014-1.442-0.079-2.16c-0.011-0.131-0.044-0.242-0.14-0.338
//   c-0.089-0.089-0.212-0.14-0.338-0.14S12.294,122.639,12.205,122.728z"
//           ></path>
//           <path
//             class="scarf"
//             d="M22.598,126.128c-0.096,0.096-0.127,0.207-0.14,0.337
//   c-0.308,3.227-0.622,6.455-1.051,9.667c0.002-0.016,0.004-0.031,0.006-0.046c-0.42,3.117-0.952,6.22-1.684,9.28
//   c-0.062,0.252,0.076,0.516,0.333,0.587c0.244,0.068,0.527-0.081,0.587-0.333c1.441-6.015,2.092-12.176,2.683-18.322
//   c0.027-0.278,0.054-0.555,0.08-0.833c0.012-0.12-0.057-0.255-0.139-0.337c-0.09-0.089-0.212-0.14-0.338-0.14
//   S22.687,126.039,22.598,126.128z M21.396,136.213c0.003-0.027,0.007-0.053,0.011-0.08C21.403,136.16,21.399,136.187,21.396,136.213z
//   "
//           ></path>
//           <path
//             class="scarf"
//             d="M21.391,122.121c-1.243,5.955-2.305,11.953-3.002,17.999
//   c-0.192,1.668-0.354,3.339-0.48,5.013c-0.02,0.261,0.232,0.478,0.478,0.478c0.126,0,0.249-0.051,0.337-0.14
//   c0.094-0.094,0.13-0.207,0.14-0.338c0.196-2.614,0.481-5.22,0.829-7.818c0,0.003,0,0.005-0.001,0.008
//   c0.678-5.014,1.586-9.995,2.62-14.947c0.027-0.128,0.02-0.252-0.048-0.368c-0.062-0.107-0.167-0.187-0.285-0.22
//   c-0.039-0.011-0.08-0.016-0.12-0.016C21.65,121.771,21.437,121.908,21.391,122.121z M19.688,137.361
//   c-0.004,0.027-0.007,0.054-0.011,0.081C19.68,137.415,19.684,137.388,19.688,137.361z"
//           ></path>
//           <path
//             class="scarf"
//             d="M29.465,147.615c0.445-6.067,0.707-12.153,0.599-18.237
//   c-0.029-1.679-0.09-3.357-0.187-5.033c-0.015-0.261-0.293-0.442-0.537-0.41c-0.125,0.017-0.239,0.083-0.315,0.183
//   c-0.082,0.106-0.102,0.223-0.095,0.354c0.151,2.616,0.213,5.237,0.21,7.859c0-0.002,0-0.005,0-0.008
//   c-0.009,5.06-0.252,10.117-0.623,15.163c-0.01,0.13,0.014,0.252,0.097,0.358c0.076,0.097,0.189,0.163,0.312,0.18
//   c0.04,0.005,0.081,0.005,0.121,0C29.254,147.996,29.449,147.833,29.465,147.615z M29.141,132.284c0-0.027,0-0.054,0-0.081
//   C29.141,132.229,29.141,132.256,29.141,132.284z"
//           ></path>
//           <path
//             class="scarf"
//             d="M20.159,122.123c-1.891,5.527-2.832,11.32-3.879,17.049
//   c-0.264,1.446-0.535,2.891-0.829,4.332c-0.026,0.129-0.02,0.251,0.048,0.368c0.062,0.106,0.166,0.186,0.285,0.219
//   c0.238,0.065,0.536-0.079,0.588-0.333c1.167-5.719,1.975-11.514,3.448-17.168c0.37-1.419,0.786-2.826,1.26-4.213
//   c0.084-0.246-0.094-0.521-0.333-0.587c-0.043-0.012-0.086-0.018-0.127-0.018C20.409,121.771,20.229,121.917,20.159,122.123z"
//           ></path>
//           <path
//             class="scarf"
//             d="M15.001,124.504c-0.009,0.894-0.08,1.785-0.193,2.671
//   c-0.336,2.491-0.981,4.93-1.701,7.334c-0.707,2.363-1.508,4.698-2.208,7.063c-0.074,0.25,0.086,0.519,0.333,0.587
//   c0.254,0.07,0.513-0.084,0.587-0.333c0.765-2.58,1.644-5.125,2.4-7.709c0.771-2.639,1.432-5.332,1.665-8.079
//   c0.043-0.511,0.066-1.023,0.071-1.536c0.003-0.26-0.218-0.478-0.477-0.478C15.217,124.027,15.004,124.244,15.001,124.504z
//    M14.803,127.22c-0.003,0.025-0.006,0.05-0.01,0.076C14.796,127.27,14.8,127.245,14.803,127.22z"
//           ></path>
//           <path
//             class="scarf"
//             d="M17.974,122.728c-0.098,0.098-0.124,0.206-0.139,0.338
//   c-0.027,0.222-0.055,0.443-0.084,0.664c-0.814,5.91-2.733,11.571-4.526,17.237c-0.181,0.572-0.36,1.145-0.538,1.719
//   c-0.077,0.249,0.089,0.52,0.333,0.587c0.256,0.07,0.51-0.085,0.587-0.334c1.763-5.699,3.779-11.347,4.8-17.242
//   c0.151-0.874,0.277-1.751,0.383-2.631c0.014-0.118-0.06-0.257-0.139-0.338c-0.09-0.089-0.212-0.14-0.338-0.14
//   C18.186,122.588,18.063,122.639,17.974,122.728z M17.76,123.659c-0.002,0.013-0.004,0.025-0.005,0.038
//   C17.756,123.684,17.758,123.671,17.76,123.659z"
//           ></path>
//           <path
//             class="scarf"
//             d="M26.863,126.717c-0.081,0.112-0.088,0.224-0.083,0.356
//   c0.01,0.223,0.019,0.446,0.025,0.668c0.164,5.963-0.805,11.862-1.647,17.746c-0.085,0.594-0.168,1.188-0.25,1.784
//   c-0.035,0.257,0.172,0.498,0.425,0.524c0.265,0.028,0.489-0.167,0.524-0.425c0.808-5.911,1.873-11.813,1.916-17.795
//   c0.006-0.887-0.013-1.772-0.052-2.658c-0.005-0.119-0.101-0.244-0.192-0.311c-0.103-0.073-0.232-0.103-0.356-0.083
//   C27.049,126.545,26.937,126.615,26.863,126.717z M26.804,127.67c0,0.013,0.001,0.025,0.001,0.039
//   C26.805,127.696,26.804,127.683,26.804,127.67z"
//           ></path>
//           <path
//             class="scarf"
//             d="M24.489,125.544c-0.082,0.111-0.091,0.223-0.086,0.355
//   c0.007,0.223,0.014,0.446,0.019,0.668c0.104,5.964-0.922,11.854-1.823,17.729c-0.091,0.593-0.18,1.187-0.268,1.781
//   c-0.038,0.257,0.167,0.5,0.42,0.529c0.264,0.03,0.491-0.163,0.529-0.42c0.865-5.902,1.99-11.793,2.092-17.775
//   c0.016-0.887,0.005-1.772-0.025-2.659c-0.004-0.119-0.098-0.245-0.19-0.312c-0.102-0.074-0.23-0.105-0.355-0.086
//   S24.564,125.442,24.489,125.544z M24.421,126.497c0,0.013,0,0.026,0,0.039C24.421,126.522,24.421,126.509,24.421,126.497z"
//           ></path>
//         </svg>
//         <p>Home</p>
//         <p>Shop</p>
//         <p>Products</p>
//         <p>Detail</p>
//         <p>Contact</p>
//       </div>

//       {/* BODY */}
//       <div style={{ height: "300vh", paddingTop: "60px", padding: "100px" }}>
//         <div
//           style={{ position: "relative", height: "450px", width: "350px" }}
//           onMouseEnter={() => setHover(() => true)}
//           onMouseLeave={() => setHover(() => false)}
//         >
//           <img
//             src="https://www.catscarf.com/cdn/shop/products/Clyde_brown_large.jpg?v=1379412622"
//             style={{ width: "100%", height: "100%", objectFit: "contain" }}
//           />

//           <div
//             style={{
//               width: "250px",
//               height: "250px",
//               position: "absolute",
//               borderRadius: "50%",
//               background: "rgba(0, 0, 0, 0.4)",
//               color: "#ffffff",
//               display: "flex",
//               flexDirection: "column",
//               textAlign: "center",
//               justifyContent: "center",
//               alignItems: "center",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               opacity: hover ? 1 : 0,
//               transition: "opacity 0.2s",
//             }}
//           >
//             <h2
//               style={{
//                 opacity: hover ? 1 : 0,
//                 transform: hover ? "translateY(0)" : "translateY(2px)",
//                 transition: "all 0.2s linear",
//               }}
//             >
//               The <br /> CLYDE
//             </h2>
//             <div
//               style={{
//                 width: "100%",
//                 height: "1px",
//                 background: "gray",
//                 opacity: hover ? 1 : 0,
//                 transform: hover ? "translateY(0)" : "translateY(2px)",
//                 transition: "all 0.3s linear",
//               }}
//             />
//             <p
//               style={{
//                 opacity: hover ? 1 : 0,
//                 transform: hover ? "translateY(0)" : "translateY(6px)",
//                 transition: "all 0.125s linear 0.15s",
//               }}
//             >
//               hello world
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;
